import "./commondialogs.scss";
import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog } from "../../Actions/Dialogs/DialogActions";
import { clearLocalData } from "../../Data/DataStores/ClearLocalData";
import Button from "../Buttons/Button";

const connector = connect();

type PropsFromRedux = ConnectedProps<typeof connector> & {
    dispatch: ThunkDispatch<any, any, any>;
};

export class ClearLocalDataDialog extends React.Component<PropsFromRedux> {
    public handleCancelClick = (): void => {
        this.props.dispatch(hideDialog());
    };

    public handleClearDataClick = (): void => {
        this.props.dispatch(hideDialog());

        clearLocalData();
    };

    public render(): React.ReactNode {
        return (
            <div className="clear-local-dialog">
                <p>Are you sure you wish to clear local data?</p>
                <p>This will remove all locally stored data and will resynchronise on refresh.</p>
                <p>We suggest not performing this without direct instruction from Shopfront.</p>
                <p>It will remove any data waiting to be uploaded.</p>
                <p><strong>This cannot be undone.</strong></p>
                <p>
                    Please ensure all other Shopfront pages are closed (including customer display)<br />
                    otherwise unexpected results may occur.
                </p>
                <div className="buttons">
                    <Button classes={[ "button-cancel" ]} onClick={this.handleCancelClick}>Cancel</Button>
                    <Button classes={[ "button-danger" ]} onClick={this.handleClearDataClick}>Yes</Button>
                </div>
            </div>
        );
    }
}

export default connector(ClearLocalDataDialog);
